(function() {
  'use strict';

  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    var parts = dollars.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  function getPriceScope() {
    var c = document.querySelector('[data-product-addon]');
    if (!c) return null;
    return c.closest('product-info') || document;
  }

  function setCombinedOnPrices(active, total) {
    var scope = getPriceScope();
    if (!scope) return;
    var els = scope.querySelectorAll('.price__regular');
    els.forEach(function(el) {
      var container = el.parentNode;
      var note = container ? container.querySelector('[data-addon-price-note]') : null;

      if (active) {
        if (el.getAttribute('data-addon-orig') === null) {
          el.setAttribute('data-addon-orig', el.innerHTML);
        }
        el.textContent = formatMoney(total);

        if (container && !note) {
          note = document.createElement('span');
          note.setAttribute('data-addon-price-note', '');
          note.className = 'addon-price-note text-sm font-normal text-opacity';
          note.textContent = 'with selected add-ons';
          container.insertBefore(note, el.nextSibling);
        }
      } else {
        var orig = el.getAttribute('data-addon-orig');
        if (orig !== null) {
          el.innerHTML = orig;
          el.removeAttribute('data-addon-orig');
        }
        if (note && note.parentNode) {
          note.parentNode.removeChild(note);
        }
      }
    });
  }

  function updateCombinedPrice() {
    var mainContainer = document.querySelector('[data-product-addon]');
    if (!mainContainer) return;

    var base = parseInt(mainContainer.getAttribute('data-main-price') || '0', 10);
    var addonTotal = 0;

    document.querySelectorAll('[data-addon-checkbox]').forEach(function(cb) {
      if (cb.checked) {
        addonTotal += parseInt(cb.getAttribute('data-addon-price') || '0', 10);
      }
    });

    setCombinedOnPrices(addonTotal > 0, base + addonTotal);
  }

  function openQuickView(url) {
    if (!url) return;
    var quickView = document.getElementById('AddonQuickView');
    if (!quickView) return;
    quickView.setAttribute('data-product-url', url);
    quickView.show();
  }

  function initAddonDropdowns() {
    var groups = document.querySelectorAll('[data-addon-group]');

    groups.forEach(function(groupContainer) {
      if (groupContainer.dataset.addonInitialized === 'true') return;
      groupContainer.dataset.addonInitialized = 'true';

      var cards = groupContainer.querySelectorAll('[data-addon-card]');
      var checkboxes = groupContainer.querySelectorAll('[data-addon-checkbox]');
      var labelSpan = groupContainer.querySelector('[data-addon-selected-label]');

      function selectCard(card) {
        // Multi-select: toggle this card independently, leaving the others as-is
        var nowSelected = !card.classList.contains('addon-card--selected');
        card.classList.toggle('addon-card--selected', nowSelected);

        var cb = card.querySelector('[data-addon-checkbox]');
        if (cb) { cb.checked = nowSelected; }

        if (labelSpan) {
          var names = [];
          cards.forEach(function(c) {
            if (c.classList.contains('addon-card--selected')) {
              var nameEl = c.querySelector('.addon-card__name');
              if (nameEl) { names.push(nameEl.textContent.trim()); }
            }
          });
          if (names.length === 0) {
            labelSpan.textContent = '';
          } else if (names.length === 1) {
            labelSpan.textContent = ' \u00b7 ' + names[0];
          } else {
            labelSpan.textContent = ' \u00b7 ' + names.length + ' selected';
          }
        }

        updateCombinedPrice();
      }

      groupContainer.addEventListener('click', function(e) {
        var qv = e.target.closest('[data-addon-quickview]');
        if (qv) {
          e.preventDefault();
          e.stopPropagation();
          openQuickView(qv.getAttribute('data-addon-quickview'));
          return;
        }
        var card = e.target.closest('[data-addon-card]');
        if (card) {
          selectCard(card);
        }
      });

      groupContainer.addEventListener('keydown', function(e) {
        var isActivate = e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32;
        if (!isActivate) return;
        var qv = e.target.closest('[data-addon-quickview]');
        if (qv) {
          e.preventDefault();
          openQuickView(qv.getAttribute('data-addon-quickview'));
          return;
        }
        var card = e.target.closest('[data-addon-card]');
        if (card) {
          e.preventDefault();
          selectCard(card);
        }
      });
    });

    updateCombinedPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAddonDropdowns);
  } else {
    initAddonDropdowns();
  }

  document.addEventListener('shopify:section:load', initAddonDropdowns);

  if (window.theme && window.theme.pubsub && window.theme.pubsub.subscribe) {
    window.theme.pubsub.subscribe('variantChange', function(data) {
      var newVariant = data && data.data && data.data.variant;
      setTimeout(function() {
        if (newVariant && typeof newVariant.price === 'number') {
          document.querySelectorAll('[data-product-addon]').forEach(function(container) {
            container.setAttribute('data-main-price', String(newVariant.price));
          });
        }
        updateCombinedPrice();
      }, 50);
    });
  }
})();